
import React from 'react';
import { CheckCircle, XCircle, HelpCircle, ChevronDown } from 'lucide-react';

const CompareTable = () => {
  return (
    <section id="compare" className="section-padding">
      <div className="container-grid">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="h2 mb-4">How We Compare</h2>
          <p className="lead max-w-2xl mx-auto">
            See why propertyads.ai is the smarter choice for real estate professionals
          </p>
        </div>
        
        {/* Comparison table */}
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr>
                <th className="p-4 text-left bg-gray-50 border-b-2 border-gray-200">Features</th>
                <th className="p-4 text-center bg-gray-50 border-b-2 border-gray-200">Agencies</th>
                <th className="p-4 text-center bg-gray-50 border-b-2 border-gray-200">Portals</th>
                <th className="p-4 text-center bg-knock-primary-20 border-b-2 border-knock-primary border-x-2 border-t-2 border-knock-primary rounded-t-lg font-display">
                  <span className="text-knock-primary font-bold">propertyads.ai</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="p-4 border-b border-gray-200 font-medium">Exclusive Leads</td>
                <td className="p-4 text-center border-b border-gray-200">
                  <XCircle size={24} className="text-knock-error mx-auto" />
                </td>
                <td className="p-4 text-center border-b border-gray-200">
                  <XCircle size={24} className="text-knock-error mx-auto" />
                </td>
                <td className="p-4 text-center border-b border-knock-primary border-x-2 border-knock-primary bg-knock-primary-20">
                  <CheckCircle size={24} className="text-knock-success mx-auto" />
                </td>
              </tr>
              <tr>
                <td className="p-4 border-b border-gray-200 font-medium">Instant WhatsApp</td>
                <td className="p-4 text-center border-b border-gray-200">
                  <HelpCircle size={24} className="text-knock-warning mx-auto" />
                </td>
                <td className="p-4 text-center border-b border-gray-200">
                  <XCircle size={24} className="text-knock-error mx-auto" />
                </td>
                <td className="p-4 text-center border-b border-knock-primary border-x-2 border-knock-primary bg-knock-primary-20">
                  <CheckCircle size={24} className="text-knock-success mx-auto" />
                </td>
              </tr>
              <tr>
                <td className="p-4 border-b border-gray-200 font-medium">One-Click Ads</td>
                <td className="p-4 text-center border-b border-gray-200">
                  <XCircle size={24} className="text-knock-error mx-auto" />
                </td>
                <td className="p-4 text-center border-b border-gray-200">
                  <XCircle size={24} className="text-knock-error mx-auto" />
                </td>
                <td className="p-4 text-center border-b border-knock-primary border-x-2 border-knock-primary bg-knock-primary-20">
                  <CheckCircle size={24} className="text-knock-success mx-auto" />
                </td>
              </tr>
              <tr>
                <td className="p-4 border-b border-gray-200 font-medium">SEO + Social</td>
                <td className="p-4 text-center border-b border-gray-200">
                  <HelpCircle size={24} className="text-knock-warning mx-auto" />
                </td>
                <td className="p-4 text-center border-b border-gray-200">
                  <XCircle size={24} className="text-knock-error mx-auto" />
                </td>
                <td className="p-4 text-center border-b border-knock-primary border-x-2 border-knock-primary bg-knock-primary-20">
                  <CheckCircle size={24} className="text-knock-success mx-auto" />
                </td>
              </tr>
              <tr>
                <td className="p-4 border-b border-gray-200 font-medium">Monthly Cost</td>
                <td className="p-4 text-center border-b border-gray-200">
                  <span className="text-knock-error font-medium">$$$</span>
                </td>
                <td className="p-4 text-center border-b border-gray-200">
                  <span className="text-knock-warning font-medium">$$</span>
                </td>
                <td className="p-4 text-center border-b border-knock-primary border-x-2 border-knock-primary bg-knock-primary-20">
                  <span className="text-knock-success font-medium">$</span>
                </td>
              </tr>
              <tr>
                <td className="p-4 border-b border-gray-200 font-medium">Setup Time</td>
                <td className="p-4 text-center border-b border-gray-200">
                  <span className="text-knock-error font-medium">Weeks</span>
                </td>
                <td className="p-4 text-center border-b border-gray-200">
                  <span className="text-knock-warning font-medium">Days</span>
                </td>
                <td className="p-4 text-center border-b-2 border-knock-primary border-x-2 border-b-2 border-knock-primary rounded-b-lg bg-knock-primary-20">
                  <span className="text-knock-success font-medium">Minutes</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <div className="mt-8 text-center">
          <a href="#solution" className="btn-primary inline-flex items-center">
            See How It Works <ChevronDown className="ml-2 h-4 w-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default CompareTable;